import { Api } from 'utils';

class CallService {
  static get = async (params = {}) => Api.createResponse('app/calls/', params);
  static disabledDays = async (params = {}) =>
    Api.createResponse('app/calls/disabled-days', params);
  static availableHours = async (params = {}) =>
    Api.createResponse('app/calls/available-hours', params);
  static create = async (params = {}) => Api.createResponse('app/calls/create', params);
  static update = async (params = {}) => Api.createResponse('app/calls/update', params);
  static rating = async (params = {}) => Api.createResponse('app/calls/rating', params);
  static cancel = async (params = {}) => Api.createResponse('app/calls/cancel', params);

  static admin = {
    get: async (params = {}) => Api.createResponse('admin/calls/', params),
  };
}

export default CallService;
